import { formatRupiah } from "@/helpers/utils";
import dayjs from "dayjs";
import { h } from "gridjs";
import { _ } from "gridjs-react";

export const columnsData = (navigate) => [
  {
    name: 'No. Rekening',
    data: (row) => row.account_number,
  },
  {
    name: 'Nama Member',
    data: (row) => row.member_name
  },
  {
    name: 'Produk Simpanan',
    data: (row) => row.id,
    formatter: (cell) => {
      return _(
        <span>
          Simpanan Wajib
        </span>
      )
    }
  },
  {
    name: 'Saldo Efektif',
    data: (row) => formatRupiah(row.balance), 
  },
  {
      name: 'Info',
      data: (row) => row,
      formatter: (row) => {
        return _(
          <div className="flex flex-col gap-3">
            <button
              className="rounded-md bg-blue-500 text-center hover:bg-blue-600 text-white py-1 p-2"
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                navigate(`/admin/list-mandatory-savings/${row.member_id}/detail`);
              }}
            >
              Detail
            </button>
          </div>
        );
      }
    }
  ]
  
export const historySavingColumns = [
  {
    name: 'Tanggal Penyetoran',
    data: (row) => row.transaction_date,
    formatter: (row) => {
      return _(
        <span>
          {dayjs(row?.transaction_date).format('DD/MM/YYYY') || 'N/A'}
        </span>
      )
    }
  },
  {
    name: 'Kode Transaksi',
    data: (row) => row.transaction_number,
  },
  {
    name: 'Keterangan',
    data: (row) => row.description || '-',
  },
  {
    name: 'Produk Simpanan',
    data: (row) => row,
    formatter: (row) => {
      return _(
        <span>{ row?.member_savings_account?.savings_type?.name }</span>
      )
    }
  },
  {
    name: 'Saldo',
    data: (row) => row.amount,
    formatter: (cell) => {
      return _(
        <span>{ formatRupiah(cell) }</span>
      )
    }
  }
]